<template lang="pug">
	div.detail-layouts(v-if="data.length > 1")
		p.detail-label Select Bedroom/Bathroom Layout
			app-tooltip(
				v-for="tooltip in tooltips",
				v-if="tooltip.Type == 'Layout' && tooltip.Visible",
				:key="tooltip.Type",
				:tip_open="tip_open",
				:text="tooltip.Text",
				@tooltipToggle="tooltipToggle")
		.detail-layout(
			v-for="item in data",
			:key="item.ID",
			:class="{'is-selected': layout == item.ID}",
			tabindex="0",
			@click="set_layout({slug: item.UrlSlug})",
			@keypress.enter="set_layout({slug: item.UrlSlug})",
			:style="styles.primary.color")
				span(:data-text="item.Title", v-if="data.length > 1") {{item.Title}}
				span(v-if="item.PriceMask === null" :data-text="'$'+item.Price.toLocaleString()") ${{item.Price.toLocaleString()}}
				span(v-if="item.PriceMask !== null" :data-text="item.PriceMask") {{item.PriceMask}}
</template>

<script>
import Theme from '@/listing-app/mixins/Theme'
import TooltipControl from '@/listing-app/mixins/TooltipControl'
import Tooltip from '@/listing-app/components/detail/Tooltip'
export default {
	name: "Layouts",
	mixins: [Theme, TooltipControl],
	props: ["data", "tooltips", "layout"],
  components: {
    appTooltip: Tooltip
  },
  data() {
		return { }
	},
  methods: {
		check_price_mask(item) {
			return !!item.PriceMask
		},
    set_layout(payload) {
			this.$emit("setLayout", payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-layouts {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.detail-label {
	font-family: HelveticaNeueW02-57Cn !important;
}

.detail-layout {
  display: flex;
  flex: 0 0 calc(50% - 10px);
  width: calc(50% - 10px);
  min-height: 60px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
	padding: 8px;
  cursor: pointer;
  text-align: center;
  font-size: 15px;
  color: $black;
	font-family: $fontFamilyHeadings;
  margin-bottom: 20px;
  background: $white;
  box-shadow: 0 0 15px $gray;
  position: relative;
  transition: transform 0.25s ease;
  z-index: 1;
	span {
		width:100%;
	}
  &:before {
    position: absolute;
    content: "";
    top: 0;
    bottom: 0;
    background: currentColor;
    transition: 0.25s ease;
    z-index: -1;
  }
  &:nth-child(odd) {
    &:after {
      right: auto;
      left: 5px;
    }
  }
  &:nth-child(odd):before {
    left: calc(100% - 7px);
    right: 0;
  }
  &:nth-child(even):before {
    right: calc(100% - 7px);
    left: 0;
  }
  &:hover {
    box-shadow: 0 0 20px darken($gray, 10%);
    transform: scale(1.075, 1.075);
  }
  &.is-disabled {
    background: $gray;
    pointer-events: none;
    box-shadow: none;
  }
  &.is-selected {
    &:nth-child(odd):before {
      left: 0;
    }
    &:nth-child(even):before {
      right: 0;
    }
    span {
      font-size: 0;
      &:after {
        content: attr(data-text);
        font-size: 15px;
        color: $white;
      }
    }
  }
}
</style>
